import { useQuery } from '@tanstack/react-query'
import HoldingsService from 'api/HoldingsService'
import PortfolioService from 'api/PortfolioService'
import { metricsSubjectKeys } from 'utils/queries/subjects'

import {
  getPortfolioTypeBySubjectType,
  MetricSubjectMatterType,
} from 'utils/types/metricsV2'

interface Props {
  subjectId: string
  subjectType: MetricSubjectMatterType
}

export const useMetricsSubjectQuery = (
  { subjectId, subjectType }: Props,
  queryOptions?
) => {
  return useQuery(
    metricsSubjectKeys.byMetricSubject(subjectId, subjectType),
    async () => {
      if (!subjectId || !subjectType) {
        return undefined
      }

      const portfolioType = getPortfolioTypeBySubjectType(subjectType)

      if (portfolioType) {
        return PortfolioService.getPortfolio(subjectId, portfolioType)
      }

      const { holdings } = await HoldingsService.getHoldings({
        page: 1,
        filters: {
          idIn: [subjectId],
        },
        companiesPerPage: 1,
      })

      return holdings[0]
    },
    queryOptions
  )
}
